<script>
  export default {
    name: 'SignUpEmailVerification',

    props: {
      email: {
        type: String,
        required: true,
      },
    },

    mounted() {
      this.$store.commit('SET_IS_EMAIL_VERIFICATION_TAB');
    },

    methods: {
      async resendVerificationEmail(email) {
        await this.$store.dispatch('resendVerificationEmail', {
          email,
        });
      },
    },
  };
</script>

<template>
  <div class="d-flex flex-column align-center white--text mt-6">
    <span class="font-size-20 font-weight-600 text-center">Check Your Email</span>

    <p class="mt-4 mb-0 text-center font-size-14">
      We’ve sent a confirmation email to
      <span class="font-weight-500 gold--text" data-test-id="check-email-message">{{ email }}</span>
      click on the link in the email to activate your account.
      <br />
      Check spam folder.
    </p>

    <span class="font-size-16 mt-6">
      Still can't find it?
      <span
        class="text-decoration-underline cursor-pointer gold--text"
        data-test-id="resend-email-link"
        @click="resendVerificationEmail(email)"
      >
        Send a link again
      </span>
    </span>
  </div>
</template>

<style scoped lang="scss">
  .font-weight-500 {
    font-weight: 500;
  }
</style>
